"use client";

import React from "react";
import { Mail, MapPin, Phone, ShieldCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} className="h-4 w-24 bg-[hsl(270,15%,85%)] animate-pulse rounded-sm" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <ul className="space-y-3">
      {menuItems.map(item => <li key={item.id}>
                  <Link to={item.href || "/"} className="text-sm text-[hsl(220,5%,45%)] hover:text-[hsl(270,20%,70%)] transition-colors duration-200 font-default">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  return <section id="footer" className="bg-[hsl(120,15%,85%)] text-[hsl(220,5%,25%)] relative overflow-hidden border-t border-[hsl(270,15%,80%)] pt-16 pb-8">
      <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-[hsl(270,20%,70%)]/30 to-transparent" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/2 h-24 bg-[hsl(270,20%,70%)]/5 blur-[100px] pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 max-w-7xl relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          
          <div className="flex flex-col items-start space-y-6">
            <Link to="/">
              <img src="https://praxis-soonwald.de/wp-content/uploads/2026/04/2-1.svg" alt="Psychologische Praxis Soonwald Logo" className="h-21 w-auto object-contain" />
            </Link>
            <p className="text-base text-[hsl(220,5%,45%)] leading-relaxed max-w-xs font-default font-light">
              Systemisch-lösungsorientierte Krisenberatung.<br />
              Hypnosystemische und körperorientierte Verfahren.<br />
              Achtsamkeit zur Stressbewältigung.
            </p>
          </div>

          <div className="flex flex-col space-y-6">
            <h3 className="font-default text-lg font-semibold tracking-tight text-[hsl(220,5%,25%)]">
              Navigation
            </h3>
            <MenuProvider menu_id="42">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          <div className="flex flex-col space-y-6">
            <h3 className="font-default text-lg font-semibold tracking-tight text-[hsl(220,5%,25%)]">
              Rechtliches
            </h3>
            <ul className="space-y-3">
                         <li>
                <Link to="/impressum" className="text-sm text-[hsl(220,5%,45%)] hover:text-[hsl(270,20%,70%)] transition-colors duration-200 font-default">
                  Impressum
                </Link>
              </li>
              <li>
                <Link to="/datenschutz" className="text-sm text-[hsl(220,5%,45%)] hover:text-[hsl(270,20%,70%)] transition-colors duration-200 font-default">
                  Datenschutz
                </Link>
              </li>
              <li>
                <Link to="/widerruf" className="text-sm text-[hsl(220,5%,45%)] hover:text-[hsl(270,20%,70%)] transition-colors duration-200 font-default">
                  Widerrufsbelehrung
                </Link>
              </li>
              <li>
                <Link to="/agb" className="text-sm text-[hsl(220,5%,45%)] hover:text-[hsl(270,20%,70%)] transition-colors duration-200 font-default">
                  AGB
                </Link>
              </li>
            </ul>
          </div>

          <div className="flex flex-col space-y-6">
            <h3 className="font-default text-lg font-semibold tracking-tight text-[hsl(220,5%,25%)]">
              Kontakt
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3 text-sm text-[hsl(220,5%,45%)] font-default">
                <MapPin className="size-4 text-[hsl(270,20%,70%)] shrink-0 mt-0.5" />
                <span className="font-light">
                  Struthof 1<br />
                  55595 Münchwald, Deutschland
                </span>
              </li>
              <li className="flex items-center space-x-3 text-sm text-[hsl(220,5%,45%)] font-default">
                <Phone className="size-4 text-[hsl(270,20%,70%)] shrink-0" />
                <span className="font-light">+49 6706 9151738</span>
              </li>
              <li className="flex items-center space-x-3 text-sm text-[hsl(220,5%,45%)] font-default">
                <Mail className="size-4 text-[hsl(270,20%,70%)] shrink-0" />
                <Link to="mailto:post@claudiachrist.de" className="hover:text-[hsl(270,20%,70%)] transition-colors font-light">
                  post@claudiachrist.de
                </Link>
              </li>
            </ul>
          </div>

        </div>

        <div className="flex flex-col space-y-6">
          <Separator className="bg-[hsl(220,5%,25%)]/10" />
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-[hsl(220,5%,45%)] font-default font-light">
              &copy; {new Date().getFullYear()} Psychologische Praxis Soonwald. Alle Rechte vorbehalten.
            </p>
            <div className="flex items-center gap-4">
              
            </div>
          </div>
        </div>
      </div>
    </section>;
}